import React from 'react';
import request from "superagent";
import ReactDOM from "react-dom";
import EventListForm from "./event_list_form";

const context = eventListContext;


window.eventListState = {
  'form': {
    // values
    'containerClass': context.formClass,
    'onSelectFieldChange': handleSelectFieldChange,
    'onSingleCheckboxFieldChange': handleSingleCheckboxChange,
		'onClickViewResults': handleClickViewResults,
    'choices': {
      'dateRanges': context.dateRanges,
      'eventCategories': context.eventCategories,
    },
    'data': {
      // default values
      'dateRange': context.dateRange,
      'eventCategory': context.eventCategory
    }
  },
  'listing': {
    'class': context.listingClass,
    'isLoading': true
  }
};


// START
document.addEventListener("DOMContentLoaded", renderAll)

function renderAll() {
  renderForm();
  refreshEvents();
}

function refreshEvents() {
  /* Show the events corresponding to the current form */
  eventListState.listing.isLoading = true;

  request
    .post(`/calendar-api/events/`)
    .type('form')
    .send({
      'csrfmiddlewaretoken': context.csrfToken,
      'date_range': eventListState.form.data.dateRange,
      'event_category': eventListState.form.data.eventCategory
    })
    .then(result => {
      if (result.body.success) {
				let eventListResults = document.querySelectorAll(`.${eventListState.listing.class}`);
				eventListResults.forEach(element => element.innerHTML = result.body.html)
        eventListState.listing.isLoading = false;
      }
      else {
        console.log("Incorrect search");
        eventListState.listing.isLoading = false;
      }
    })
    .catch(err => {
      console.log(err.message, []);
      eventListState.listing.isLoading = false;
    });
}


function renderForm() {
  const mount_point = document.getElementsByClassName(eventListState.form.containerClass)[0];
  mount_form_component(mount_point);
}


function mount_form_component(mount_point) {
  ReactDOM.render(
    <EventListForm eventListState={eventListState} />,
    mount_point
  );
}


function handleSelectFieldChange(form, fieldName, event) {
  form.data[fieldName] = event.target.value;
  updateUrlBasedOnSelection();
  renderAll();
}


function handleSingleCheckboxChange(form, fieldName, e) {
  // for a boolean field
  form.data[fieldName] = e.target.checked;
  form.hasChanged = true;
  updateUrlBasedOnSelection();
  renderAll();
}


function updateUrlBasedOnSelection() {
  let queryString = Object.keys(eventListState.form.data).reduce(function(result, key) {
    if (eventListState.form.data[key] || eventListState.form.data[key] === false) {
      if (result) {
        result += '&';
      }
      result += key + '=' + eventListState.form.data[key];
    }
    return result;
  }, '');

  let url = window.location.pathname + '?' + queryString;
  window.history.replaceState(null, null, url);
}


function handleClickViewResults(event) {
	event.preventDefault();

	// A tab index is necessary for a div to be focused on via JS
	let element = document.querySelector('#event-list-results')
	element.getAttribute("tabindex", -1).focus()
}
